import { createFileRoute } from '@tanstack/react-router'

import { LearnpathsSectionRowTopic } from '@/learnpaths-assigned-page/components/LearnpathsSectionRowTopic/LearnpathsSectionRowTopic'
import useAssignedLearnpath from '@/learnpaths-assigned/hooks/useAssignedLearnpath'

export const Route = createFileRoute(
  '/_learning/_company/_list/learnpaths/view/$learnpathId/{-$elementId}/{-$topic}',
)({
  component: RouteComponent,
})

function RouteComponent() {
  const { learnpathId } = Route.useParams()
  const learnpath = useAssignedLearnpath({ learnpathId })

  if (!learnpath) {
    return null
  }

  return <LearnpathsSectionRowTopic learnpath={learnpath} />
}
